import { combineReducers } from 'redux';

import Layout from './layout/reducer';

import Auth from './auth/reducer';
import Dashboard from './dashboard/reducer';
import Leads from './leads/reducer';
import People from './people/reducer';
import Audience from './audiences/reducer';
import DailyFBCampaignInsights from './facebookAd/dailyCampaignInsights/reducer';
import DailyGoogleCampaignInsights from './googleAd/dailyCampaignInsights/reducer';
import DailyTiktokCampaignInsights from './tiktokAd/dailyCampaignInsights/reducer';
import Customer from './customers/reducer';
import DailyCustomerInsights from './customers/dailyInsights/reducer';
import AcquisitionOrder from './acquisitionOrders/reducer';
import MonetizationOrder from './monetizationOrders/reducer';
import DailyMonetizationOrderInsights from './monetizationOrders/dailyInsights/reducer';
import MonetizationItem from './monetizationItems/reducer';
import MarketingCampaign from './marketingCampaigns/reducer';
import LeadField from './leadFields/reducer';
import LeadForm from './leadForms/reducer';
import Campaign from './campaigns/reducer';
import DailyCampaignInsights from './campaigns/dailyInsights/reducer';
import Survey from './surveys/reducer';
import SurveyForm from './surveyForms/reducer';
import MessageTemplate from './messageTemplates/reducer';
import SmsMessage from './smsMessages/reducer';
import PushNotification from './pushNotifications/reducer';
import Call from './calls/reducer';
import CallInsights from './callInsights/reducer';
import NextCall from './nextCall/reducer';
import Supplier from './suppliers/reducer';
import Dealer from './dealers/reducer';
import LocalAgency from './localAgencies/reducer';
import DailySaleInsights from './suppliers/dailySaleInsights/reducer';
import DailyPublisherInsights from './suppliers/dailyPublisherInsights/reducer';
import User from './users/reducer';
import Company from './companies/reducer';
import DailyCompanyInsights from './companies/dailyInsights/reducer';
import ShortLink from './shortLinks/reducer';
import DemTemplate from './demTemplates/reducer';
import AiAgent from './aiAgents/reducer';
import AiConversation from './aiConversations/reducer';
import AiConversationMonitor from './aiConversationMonitor/reducer';
import AiSimulation from './aiSimulation/reducer';
import Dems from './dems/reducer';

const rootReducer = combineReducers({
  Layout,
  Auth,
  Dashboard,
  Leads,
  People,
  Audience,
  DailyFBCampaignInsights,
  DailyGoogleCampaignInsights,
  DailyTiktokCampaignInsights,
  Customer,
  DailyCustomerInsights,
  AcquisitionOrder,
  MonetizationOrder,
  DailyMonetizationOrderInsights,
  MonetizationItem,
  MarketingCampaign,
  LeadField,
  LeadForm,
  Campaign,
  DailyCampaignInsights,
  Survey,
  SurveyForm,
  MessageTemplate,
  SmsMessage,
  PushNotification,
  Call,
  CallInsights,
  NextCall,
  Supplier,
  Dealer,
  LocalAgency,
  DailySaleInsights,
  DailyPublisherInsights,
  User,
  Company,
  DailyCompanyInsights,
  ShortLink,
  DemTemplate,
  AiAgent,
  AiConversation,
  AiConversationMonitor,
  AiSimulation,
  Dems,
});

export default rootReducer;
